import React, { useMemo, useState } from 'react';

import { useForm } from 'react-hook-form';
import { ObjectSchema } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import {
  TestsFormState,
  TestsFormContext,
  testsSchemaDefault,
  testsFormStateDefault,
} from '@Forms/tests/TestsFormContext';

export const TestsFormProvider: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const [schema, setSchema] = useState<ObjectSchema<Partial<TestsFormState>>>(testsSchemaDefault);
  const methods = useForm({
    defaultValues: testsFormStateDefault,
    resolver: yupResolver(schema),
  });
  const value = useMemo(() => ({ schema, setSchema, methods }), [schema, setSchema, methods]);

  return <TestsFormContext.Provider value={value}>{children}</TestsFormContext.Provider>;
};
